import React, { useEffect, useState } from 'react';
import SweetAlertModal from '../../../components/SweetAlertModal/SweetAlertModal';
import Cancel from './../../../../assets/icons/close.png';
import itemImg from './../../../../assets/icons/menu.png';
import CustomDataGrid from '../../../components/CustomDataGrid/CustomDataGrid.tsx';
import { ToastContainer, toast } from 'react-toastify'
import Typography from '@mui/material/Typography'
import AutoCompleteMultiSelect from '../../../../pages/components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx'
import { styled } from "@mui/material/styles";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

//import "./ArchiveDialog.css";

import axios from 'axios';

import {
  Button,
  Grid,
  Switch,
  Dialog,
  DialogActions,
  DialogContent, 
  DialogContentText,
  DialogTitle,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  tooltipClasses,
  Tooltip,
} from '@mui/material';

function MenuCopyDialog(props) {
  console.log(props);

  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [openMenuCloseConfirmaitonModal, setopenMenuCloseConfirmaitonModal] =useState(false);
  const [openArchiveConfirmaitonModal, setopenArchiveConfirmaitonModal] =useState(false);
  const [selectedValue, setSelectedValue] = useState<any>(null);
  const [dataRows, setDataRows] = useState([]);
  const [menuSelected, setmenuSelected] = useState([]);

  const [selectedDataRows, setSelectedDatarows] = React.useState([]);

  const getselectedData = (props) => {
    console.log(props);
    setSelectedDatarows(props);
  };

const typrOfMenuDatas = [
    { id: 2, title: 'Online' },
    { id: 3, title: 'Whole sales' },
    { id: 4, title: 'Corporate ' },
    { id: 4, title: 'Instore ' },
]

  const handleClose = () => {
    props.onHandleAddItem(restaurantId);
    // setKeyword(null)
    setSelectedValue(null);
    setopenMenuCloseConfirmaitonModal(false);
    setopenArchiveConfirmaitonModal(false);
    setOpenDialog(false);
    setRestaurantId([]);
    
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedRowId(null);
  };

  const { open, onClose, dialogType, id,cancledRes,addedNewRes, onToggleSwitch ,selectedRestaurants,openDialog: toggle } = props;

  console.log(cancledRes);
  console.log(addedNewRes);
  console.log(props);
  
const apiAddress = process.env.REACT_APP_SECRET;

  const [restaurantId, setRestaurantId] = useState([]);
  const [copyMenuId, setcopyMenuId] = useState([]);

  useEffect(() => {
  }, []);

  const menuAddedvalue = (props) => {
    setmenuSelected(props);
    console.log(props)
  };

  const copySubmit = () => {

    if (menuSelected.length == 0) {
      toast.error("Please select a Menu!!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    else if(KitchenSelected.length == 0){
      toast.error("Please select a Kitchen!!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    else{
      if (menuSelected) {
        var obj = [];
  
        console.log(menuSelected)
  
        menuSelected.map((dt, i) => {
          console.log(dt.id)
          if(copyMenuId.find(x=>x==dt.id)==undefined){       
            copyMenuId.push(dt.id);
            
          }
          console.log(copyMenuId)
          
        });
        console.log(copyMenuId)
  
        obj=copyMenuId;
        
        console.log(obj[0])
  
        console.log(addedNewRes[0].id)
  
        axios
          .post(apiAddress + '/api/Menu/CopyMenu_PostNewMenu?id='+obj[0]+
            '&restaurantId='+addedNewRes[0]?.id+
            '&kitchenId='+KitchenSelected[0]?.id+
            '&activeMenuId='+addedNewRes[0]?.activeMenu+
            '&islink='+switchCheck+
            '&islinkall='+switchCheck2nd
          )
          .then((response) => {
            console.log(response.data);
            toast.success("Menu Succesfully Copied", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
          });
  
  
           props.onHandleAddItem();
      //     setSelectedValue(null);
           setopenMenuCloseConfirmaitonModal(false);
           setopenArchiveConfirmaitonModal(false);
           setOpenDialog(false);
      //     setRestaurantId([]);
      //     //cancledRes=[];
      });
    }
    }
}
const [KitchenSelected, setKitchenSelected] = useState([]);
const [kitchenDatas, setkitchenDatas] = useState([]);

const kitchenAddedvalue = (props) => {
  console.log(props);
  setKitchenSelected(props);
};

useEffect(() => {
  LoadKitchenData()
  console.log(addedNewRes)
}, [addedNewRes]);

const LoadKitchenData = () => {
  if(addedNewRes.length > 0){
    axios
    .get(apiAddress + '/api/Kitchen/GetKitchenListByResId?Id='+ addedNewRes[0].id)
    .then((response) => {
      console.log(response.data);
      var list = [];
      response.data.map((dt, i) => {
        var obj = {
          id: dt.id,
          title: dt.name,
        };
        list.push(obj);
      });
      console.log(list);
      setkitchenDatas(list);
      //loadEditRestaurant(list);
    });
  }

}

const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 320,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
  },
}));

const [switchCheck, setswitchCheck] = useState(false);
const [switchCheck2nd, setswitchCheck2nd] = useState(false);

const handleSwitchChange = () => {
  setswitchCheck(!switchCheck);
};
const handleSwitch2ndChange = () => {
  setswitchCheck2nd(!switchCheck2nd);
};

  return (
    <div>
      <React.Fragment>
        <Dialog
          maxWidth={'md'}
          fullWidth={true}
          open={props.open}
          onClose={handleClose}
        >
          <SweetAlertModal
            headerText={'Do you want to leave without saving?'}
            bodyText={'All changes made will be lost'}
            open={openMenuCloseConfirmaitonModal}
            onyes={handleClose}
            close={() => {
              setopenMenuCloseConfirmaitonModal(false);
            }}
            id={2}
          />

            <SweetAlertModal
            headerText={'Are you sure?'}
            bodyText={'Do you want to copy this menu!'}
            open={openArchiveConfirmaitonModal}
            onyes={copySubmit}
            close={() => {
              setopenArchiveConfirmaitonModal(false);
            }}    
          />
          <Grid container>
            <Grid item xs={6}>
              <DialogTitle>
                <div className='d-flex' style={{ gap: '8px' }}>
                  <div>
                    <img src={itemImg} style={{ width: '1.8rem' }} alt='' />
                  </div>

                  <span style={{ color: '#2a7fd4' }}>
                    GoTaste :- {dialogType}
                  </span>
                </div>
              </DialogTitle>
            </Grid>
            <Grid item xs={6}>
              <DialogActions>
                <Button onClick={() => setopenMenuCloseConfirmaitonModal(true)}>
                  <img src={Cancel} alt='Close' style={{ width: '1.2rem' }} />
                </Button>
              </DialogActions>
            </Grid>
          </Grid>
          <DialogContent style={{ backgroundColor: '#f3f0f3' }}>
            <div>
            <Grid container sx={{ padding: '0.5rem' }}>
            <Grid item xs={1}>
                <Typography style={{ paddingTop: '2rem' }}>
                Menu
                </Typography>
            </Grid>
            <Grid item xs={11} style={{ paddingTop: '1rem' }}>
                <AutoCompleteMultiSelect
                id={2}
                placeholder={'Select a menu'}
                datas={cancledRes}
                multiple={false}
                value={menuAddedvalue}
                val={menuSelected}
                />
            
            </Grid>
            </Grid>
            </div>
            <div>
              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={1}>
                  <Typography style={{ paddingTop: "2rem" }}>Kitchen</Typography>
                </Grid>
                <Grid item xs={11} style={{ paddingTop: "1rem" }}>
                  <AutoCompleteMultiSelect
                    id={2}
                    placeholder={"Select a Kitchen"}
                    datas={kitchenDatas}
                    value={kitchenAddedvalue}
                    val={KitchenSelected}
                  />
                </Grid>
              </Grid>
            </div>

            <div>
            <Grid container sx={{ padding: "0.5rem" }}>
            <Grid item xs={2}>
                <div
                  className="d-flex"
                  style={{ paddingTop: "1rem", gap: "10px" }}
                >
                  <Typography>Apply Linkage</Typography>
                  <HtmlTooltip
                    title={
                      <React.Fragment>
                        <Typography color="inherit">
                          This option allow you to link newly created menu with other menu within the list. 
                        </Typography>
                      </React.Fragment>
                    }
                  >
                    <InfoOutlinedIcon style={{ color: "#371B17" }} />
                  </HtmlTooltip>
                </div>
              </Grid>
              <Grid item xs={9} sx={{ padding: "0.5rem" }}>
                <Switch
                  checked={switchCheck}
                  onChange={handleSwitchChange}
                  inputProps={{ "aria-label": "controlled" }}
                />
              </Grid>
            </Grid>

            {switchCheck && (
              <Grid container sx={{ padding: "0.5rem" }}>
              <Grid item xs={2}>
                <div
                  className="d-flex"
                  style={{ paddingTop: "1rem", gap: "10px" }}
                >
                  <Typography>Apply Linkage to all Menus linked with Active Menu</Typography>
                  <HtmlTooltip
                    title={
                      <React.Fragment>
                        <Typography color="inherit">
                        "Toggle On" will link the newly created menu with the active menu as well as any linked menu that are associated with the active menu. 
                        "Toggle Off" will only link the newly created menu to the menu selected above.
                        </Typography>
                      </React.Fragment>
                    }
                  >
                    <InfoOutlinedIcon style={{ color: "#371B17" }} />
                  </HtmlTooltip>
                </div>
              </Grid>
              <Grid item xs={9} sx={{ padding: "0.5rem" }} >
                <Switch
                  checked={switchCheck2nd}
                  onChange={handleSwitch2ndChange}
                  inputProps={{ "aria-label": "controlled" }}
                />
              </Grid>
            </Grid>
            )}
            </div>
            </DialogContent>
          <DialogActions>
          <Button
            onClick={() => setopenArchiveConfirmaitonModal(true) }
            color='error'
            >
            Copy
            </Button>
            <Button
                onClick={() => setopenMenuCloseConfirmaitonModal(true)}
                color='primary'
            >
                Close
            </Button>
            </DialogActions>
        </Dialog>
      </React.Fragment>
    </div>
  );
}

export default MenuCopyDialog;
